import {
    CoreEnv,
    CoreRequest,
    CoreUser,
    GASettingKeys,
} from '@eventbrite/context-gen';
import React from 'react';

export const useEnvContext = () => {
    const value = React.useContext(EnvContext);

    if (value === undefined) {
        throw new Error('useEnvContext must be used within EnvProvider');
    }

    return value;
};

interface EnvContextShape {
    env: CoreEnv;
    user?: CoreUser;
    gaSettings: GASettingKeys;
    request?: CoreRequest;
    app_name: string;
    app_version?: string;
    isBotRequest?: boolean;
}

export const EnvContext = React.createContext<Partial<EnvContextShape>>({});

interface EnvProviderProps {
    env: CoreEnv;
    user?: CoreUser;
    gaSettings: GASettingKeys;
    request?: CoreRequest;
    app_name: string;
    app_version?: string;
    isBotRequest?: boolean;
}

//TODO: Potentially add facebook options or feature flags.
/**
 * Env Provider that holds static information passed from
 * server to the client that won't update during the
 * course of the current session.
 *
 * @param props
 * @returns
 */
export const EnvProvider: React.FunctionComponent<EnvProviderProps> = (
    props,
) => {
    const {
        env,
        user,
        gaSettings,
        request,
        app_name,
        app_version,
        isBotRequest,
    } = props;
    const [value] = React.useState({
        env,
        user,
        gaSettings,
        request,
        app_name,
        app_version,
        isBotRequest,
    });

    return (
        <EnvContext.Provider value={value}>
            {props.children}
        </EnvContext.Provider>
    );
};

export default EnvProvider;
